export default __webpack_public_path__ + "1c9af1aa9126f59f434d3044751ebe54.jpeg";